import * as React from 'react'
import styles from '../styles'
import { DocuSignLogo } from '@ds/ui'

interface HeaderDocuSignLogoProps {
  dark?: boolean
  appName?: string
}

export const HeaderDocuSignLogo = ({
  appName,
  dark,
}: HeaderDocuSignLogoProps) => {
  return (
    <>
      <span css={styles.appLogoCSS}>
        <DocuSignLogo color={dark ? 'white' : undefined} />
      </span>
      {appName && (
        <span css={styles.appLogoNonProdCSS({ dark })}>{appName}</span>
      )}
    </>
  )
}

export default HeaderDocuSignLogo
